export default "__VITE_ASSET__Mjv2kT$t__"